export const removeSubtitles = videoElement => {
  const tracks = videoElement.getElementsByTagName("track");
  Array.from(tracks).forEach(track => {
    track.remove();
  });
};
